// import React from "react";

// export default function Footer() {
//   return (
//     <footer style={styles.footer}>
//       <div style={styles.container}>
//         <div style={styles.col}>
//           <h3 style={styles.logo}>Delhi Public School Ladwa</h3>
//           <p style={styles.text}>
//             A place where learning, care, and values come together to build a bright future.
//           </p>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Quick Links</h4>
//           <a href="#about" style={styles.link}>About Us</a>
//           <a href="#gallery" style={styles.link}>Gallery</a>
//           <a href="#contact" style={styles.link}>Contact</a>
//           <a href="#admissions" style={styles.link}>Admissions</a>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Contact</h4>
//           <p style={styles.text}>📍 Ladwa, Haryana</p>
//           <p style={styles.text}>📞 +91 87489 95555</p>
//           <p style={styles.text}>✉️ info@dpskidsladwa.com</p>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Follow Us</h4>
//           <div style={styles.social}>
//             <span style={styles.socialIcon}>📘</span>
//             <span style={styles.socialIcon}>📸</span>
//             <span style={styles.socialIcon}>▶️</span>
//           </div>
//         </div>
//       </div>

//       <div style={styles.bottom}>
//         <p style={{ margin: 0 }}>
//           © 2026 Delhi Public School Ladwa. All Rights Reserved.
//         </p>
//       </div>
//     </footer>
//   );
// }

// const styles = {
//   footer: {
//     background: "linear-gradient(180deg, #0f3d1f 0%, rgb(0, 111, 47) 100%)",
//     color: "#fff",
//     marginTop: "60px",
//   },
//   container: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "60px 20px 30px",
//     display: "grid",
//     gridTemplateColumns: "repeat(4, 1fr)",
//     gap: "30px",
//   },
//   col: {
//     minWidth: "200px",
//   },
//   logo: {
//     fontSize: "24px",
//     fontWeight: "700",
//     marginBottom: "15px",
//   },
//   heading: {
//     fontSize: "18px",
//     marginBottom: "18px",
//     fontWeight: "700",
//     color: "#ffffff",
//   },
//   text: {
//     color: "rgba(255,255,255,0.85)",
//     lineHeight: "1.8",
//     fontSize: "14px",
//     margin: "0 0 10px",
//   },
//   link: {
//     display: "block",
//     color: "rgba(255,255,255,0.85)",
//     textDecoration: "none",
//     marginBottom: "10px",
//     fontSize: "14px",
//     transition: "0.3s",
//   },
//   social: {
//     display: "flex",
//     gap: "12px",
//     marginTop: "10px",
//   },
//   socialIcon: {
//     width: "40px",
//     height: "40px",
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.12)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "18px",
//     cursor: "pointer",
//     transition: "0.3s",
//   },
//   bottom: {
//     textAlign: "center",
//     padding: "16px 20px",
//     borderTop: "1px solid rgba(255,255,255,0.15)",
//     fontSize: "14px",
//     color: "rgba(255,255,255,0.8)",
//   },
// };

// import React from "react";

// export default function Footer() {
//   return (
//     <footer style={styles.footer}>
//       <div style={styles.container}>
//         <div style={styles.col}>
//           <h3 style={styles.logo}>Delhi Public School Ladwa</h3>
//           <p style={styles.text}>
//             A place where learning, care, and values come together to build a bright future.
//           </p>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Quick Links</h4>
//           <a href="#about" style={styles.link}>About Us</a>
//           <a href="#gallery" style={styles.link}>Gallery</a>
//           <a href="#contact" style={styles.link}>Contact</a>
//           <a href="#admissions" style={styles.link}>Admissions</a>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Contact</h4>
//           <p style={styles.text}>📍 Ladwa, Haryana</p>
//           <p style={styles.text}>📞 +91 87489 95555</p>
//           <p style={styles.text}>✉️ info@dpskidsladwa.com</p>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Follow Us</h4>
//           <div style={styles.social}>
//             <span style={styles.socialIcon}>📘</span> {/* Facebook */}
//             <span style={styles.socialIcon}>📷</span>  {/* Instagram */}
//             <span style={styles.socialIcon}>🐦</span>  {/* Twitter/X */}
//           </div>
//         </div>
//       </div>

//       <div style={styles.bottom}>
//         <p style={{ margin: 0 }}>
//           © 2026 Delhi Public School Ladwa. All Rights Reserved.
//         </p>
//       </div>
//     </footer>
//   );
// }

// const styles = {
//   footer: {
//     background: "linear-gradient(180deg, #0f3d1f 0%, rgb(0, 111, 47) 100%)",
//     color: "#fff",
//     marginTop: "60px",
//   },
//   container: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "60px 40px 40px",  // ✅ Left padding
//     display: "grid",
//     gridTemplateColumns: "repeat(4, 1fr)",
//     gap: "40px 60px",          // ✅ Proper gaps
//   },
//   col: {
//     minWidth: "200px",
//     textAlign: "left"          // ✅ LEFT ALIGNED!
//   },
//   logo: {
//     fontSize: "24px",
//     fontWeight: "700",
//     marginBottom: "15px",
//   },
//   heading: {
//     fontSize: "18px",
//     marginBottom: "18px",
//     fontWeight: "700",
//     color: "#ffffff",
//   },
//   text: {
//     color: "rgba(255,255,255,0.85)",
//     lineHeight: "1.8",
//     fontSize: "14px",
//     margin: "0 0 10px",
//   },
//   link: {
//     display: "block",
//     color: "rgba(255,255,255,0.85)",
//     textDecoration: "none",
//     marginBottom: "10px",
//     fontSize: "14px",
//     transition: "0.3s",
//   },
//   link: {
//     ":hover": {
//       color: "#fff",
//       paddingLeft: "10px"     // ✅ Smooth slide effect
//     }
//   },
//   social: {
//     display: "flex",
//     gap: "15px",              // ✅ Proper spacing
//     marginTop: "10px",
//     alignItems: "flex-start"  // ✅ LEFT aligned
//   },
//   socialIcon: {
//     width: "44px",
//     height: "44px",
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.15)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "20px",
//     cursor: "pointer",
//     transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//   },
//   socialIcon: {
//     ":hover": {
//       background: "rgba(255,255,255,0.3)",
//       transform: "scale(1.1) translateY(-3px)",
//       boxShadow: "0 8px 25px rgba(255,255,255,0.2)"
//     }
//   },
//   bottom: {
//     textAlign: "center",
//     padding: "20px 40px",
//     borderTop: "1px solid rgba(255,255,255,0.15)",
//     fontSize: "14px",
//     color: "rgba(255,255,255,0.8)",
//   },
// };

// import React from "react";
// import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

// export default function Footer() {
//   return (
//     <footer style={styles.footer}>
//       <div style={styles.container}>
        
//         <div style={styles.col}>
//           <h3 style={styles.logo}>Delhi Public School Ladwa</h3>
//           <p style={styles.text}>
//             A place where learning, care, and values come together to build a bright future.
//           </p>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Quick Links</h4>
//           <a href="#about" style={styles.link}>About Us</a>
//           <a href="#gallery" style={styles.link}>Gallery</a>
//           <a href="#contact" style={styles.link}>Contact</a>
//           <a href="#admissions" style={styles.link}>Admissions</a>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Contact</h4>
//           <p style={styles.text}>📍 Ladwa, Haryana</p>
//           <p style={styles.text}>📞 +91 87489 95555</p>
//           <p style={styles.text}>✉️ info@dpskidsladwa.com</p>
//         </div>

//         <div style={styles.col}>
//           <h4 style={styles.heading}>Follow Us</h4>
//           <div style={styles.social}>
//             <a href="#" style={styles.socialIcon}><FaFacebookF /></a>
//             <a href="#" style={styles.socialIcon}><FaInstagram /></a>
//             <a href="#" style={styles.socialIcon}><FaTwitter /></a>
//           </div>
//         </div>

//       </div>

//       <div style={styles.bottom}>
//         <p style={{ margin: 0 }}>
//           © 2026 Delhi Public School Ladwa. Created by Divy Digital Hub.
//         </p>
//       </div>
//     </footer>
//   );
// }

// const styles = {
//   footer: {
//     background: "linear-gradient(180deg, #0f3d1f 0%, rgb(0, 111, 47) 100%)",
//     color: "#fff",
//     marginTop: "60px",
//   },

//   container: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "60px 20px 30px",
//     display: "grid",
//     gridTemplateColumns: "repeat(4, 1fr)",
//     gap: "30px",
//     textAlign: "left", // ✅ IMPORTANT (left align)
//   },

//   col: {
//     minWidth: "200px",
//   },

//   logo: {
//     fontSize: "24px",
//     fontWeight: "700",
//     marginBottom: "15px",
//     textAlign: "left",
//   },

//   heading: {
//     fontSize: "18px",
//     marginBottom: "18px",
//     fontWeight: "700",
//     color: "#ffffff",
//     textAlign: "left",
//      fontFamily: 'sans-serif',
//   },

//   text: {
//     color: "rgba(255,255,255,0.85)",
//     lineHeight: "1.8",
//     fontSize: "14px",
//     margin: "0 0 10px",
//     textAlign: "left",
//      fontFamily: 'sans-serif',
//   },

//   link: {
//     display: "block",
//     color: "rgba(255,255,255,0.85)",
//     textDecoration: "none",
//     marginBottom: "10px",
//     fontSize: "14px",
//   },

//   social: {
//     display: "flex",
//     gap: "12px",
//     marginTop: "10px",
//     justifyContent: "flex-start", // ✅ left align icons
//   },

//   socialIcon: {
//     width: "40px",
//     height: "40px",
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.12)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "18px",
//     cursor: "pointer",
//     color: "#fff",
//     textDecoration: "none",
//      fontFamily: 'sans-serif',
//   },

//   bottom: {
//     textAlign: "center",
//     padding: "16px 20px",
//     borderTop: "1px solid rgba(255,255,255,0.15)",
//     fontSize: "14px",
//     color: "rgba(255,255,255,0.8)",
//      fontFamily: 'sans-serif',
//   },
// };

import React, { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import  logo from "./dpslogo.png";
import { useNavigate, useLocation } from 'react-router-dom';
export default function Footer() {

  const [screen, setScreen] = useState(window.innerWidth);
const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => setScreen(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = screen <= 768;
  const isTablet = screen <= 1024;

  return (
    <footer style={styles.footer}>
      <div
        style={{
          ...styles.container,
          gridTemplateColumns: isMobile
            ? "1fr"
            : isTablet
            ? "repeat(2, 1fr)"
            : "repeat(4, 1fr)",
          textAlign: isMobile ? "center" : "left",
        }}
      >
        
        <div style={styles.col}>
          {/* <h3 style={{ ...styles.logo, textAlign: isMobile ? "center" : "left" }}>
            Delhi Public School Ladwa
          </h3> */}
     <img 
        src={logo} 
        alt="DPS Kids Ladwa" 
        style={{ 
          height: "clamp(50px, 5vw, 90px)", // 🔥 responsive size
          objectFit: "contain",
          marginTop:27
        }}
      />
          <p style={{ ...styles.text, textAlign: isMobile ? "center" : "left" }}>
            A place where learning, care, and values come together to build a bright future.
          </p>
        </div>

        <div style={styles.col}>
          <h4 style={{ ...styles.heading, textAlign: isMobile ? "center" : "left" }}>
            Quick Links
          </h4>
          <a href="#about" style={styles.link}>About Us</a>
          <a href="#gallery" style={styles.link}>Gallery</a>
          <a href="#contact" style={styles.link}>Contact</a>
          <a href="#admissions" style={styles.link}>Admissions</a>
        </div>

        <div style={styles.col}>
          <h4 style={{ ...styles.heading, textAlign: isMobile ? "center" : "left" }}>
            Contact
          </h4>
          <p style={{ ...styles.text, textAlign: isMobile ? "center" : "left" }}>
            📍 Ladwa, Haryana
          </p>
          <p style={{ ...styles.text, textAlign: isMobile ? "center" : "left" }}>
            📞 +91 90534 90023
          </p>
          <p style={{ ...styles.text, textAlign: isMobile ? "center" : "left" }}>
            ✉️ dpskidsladwa@gmail.com
          </p>
        </div>

        <div style={styles.col}>
          <h4 style={{ ...styles.heading, textAlign: isMobile ? "center" : "left" }}>
            Follow Us
          </h4>
          <div
            style={{
              ...styles.social,
              justifyContent: isMobile ? "center" : "flex-start",
            }}
          >
            <a href="https://www.facebook.com/dpskidsladwa" style={styles.socialIcon}><FaFacebookF /></a>
            <a href="https://www.instagram.com/dpskids_ladwa" style={styles.socialIcon}><FaInstagram /></a>
            {/* <a href="#" style={styles.socialIcon}><FaTwitter /></a> */}
        
          </div>
          {/* <div style={styles.acol}>


<h3 style={{ ...styles.logo, textAlign: isMobile ? "center" : "left" }}>
            Affiliation Approval Letter
          </h3>
          </div> */}
{/* <div
 
  style={{
    ...styles.acol,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "rgb(0,111,47)";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#fff";
    e.currentTarget.style.color = "rgb(0,111,47)";
  }}
  onClick={() => navigate("/SchoolCertificates")}
>
  
  <h3
    style={{
      ...styles.logo,
      textAlign: isMobile ? "center" : "left",
      margin: 0
    }}
  >
    Affiliation Approval Letter
  </h3>
</div> */}
<div
 
  style={{
    ...styles.acol,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "rgb(0,111,47)";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#fff";
    e.currentTarget.style.color = "rgb(0,111,47)";
  }}
    onClick={() => navigate("/SchoolCertificates")}
>
  
  <h3
    style={{
      ...styles.logo,
      textAlign: isMobile ? "center" : "left",
      margin: 0
    }}
  >
    Mandatory Disclosure
  </h3>
</div>

        </div>

      </div>

      <div style={styles.bottom}>
        {/* <p style={{ margin: 0 }}>
          © 2026 Delhi Public School Ladwa. Created by Divy Digital Hub.
        </p> */}
        <p style={{ margin: 0 }}>
  © 2026 Delhi Public School Ladwa. Created by{" "}
  <a
    href="https://divydigitalhub.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color: "#3b82f6",
      textDecoration: "none",
      fontWeight: "500",
    }}
  >
    Divy Digital Hub
  </a>
</p>

      </div>

    </footer>
  );
}

const styles = {
  footer: {
    background: "linear-gradient(180deg, #0f3d1f 0%, rgb(0, 111, 47) 100%)",
    color: "#fff",
    marginTop: "0px",
  },

  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "60px 20px 30px",
    display: "grid",
    gap: "30px",
  },

  col: {
    minWidth: "200px",
    marginTop:-50
    
  },
    acol: {
  background: "#fff",
  color: "rgb(0,111,47)",
  display: "inline-block",   // 🔥 main fix
  padding: "6px 14px",
  borderRadius: "6px",
  cursor: "pointer",         // 🔥 clickable feel
  transition: "0.3s",
  marginTop:10
},

  logo: {
    fontSize: "15px",
    fontWeight: "700",
    marginBottom: "15px",
    color:'rgb(0, 111, 47) 100%)'
    
  },

  heading: {
    fontSize: "18px",
    marginBottom: "18px",
    fontWeight: "700",
     
  },

  text: {
    color: "rgba(255,255,255,0.85)",
    lineHeight: "1.8",
    fontSize: "14px",
    margin: "0 0 10px",
   
  },

  link: {
    display: "block",
    color: "rgba(255,255,255,0.85)",
    textDecoration: "none",
    marginBottom: "10px",
    fontSize: "14px",
  },

  social: {
    display: "flex",
    gap: "12px",
    marginTop: "10px",
  },

  socialIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    cursor: "pointer",
    color: "#fff",
    textDecoration: "none",
    transition: "0.3s",
  },

  bottom: {
    textAlign: "center",
    padding: "16px 20px",
    borderTop: "1px solid rgba(255,255,255,0.15)",
    fontSize: "14px",
    color: "rgba(255,255,255,0.8)",
  },
};